module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"a-tree-within\"-in-fullerton-california-14d5c5070a30b1373636e05fcf99ea7d.png";